module.exports = __webpack_public_path__ + "static/media/homeBackground2.6b295ee2.png";